import {logout} from '@/api';
import {Toaster} from '@/toaster.ts';
import {Alignment, Button, Navbar as BpNavbar} from '@blueprintjs/core';
import classNames from 'classnames';
import {ReactElement, useCallback} from 'react';
import {Link, useMatch, useNavigate} from 'react-router';

export default function Navbar(): ReactElement {
	const navigate = useNavigate();

	const onLogoutClick = useCallback(() => {
		logout();
		Toaster.info('You have been logged out.');

		navigate('/login');
	}, []);

	return (
		<BpNavbar>
			<BpNavbar.Group align={Alignment.START}>
				<BpNavbar.Heading>
					Inventory Hub
				</BpNavbar.Heading>

				<BpNavbar.Divider />

				<Link to="/feeds">
					<Button
						icon="shapes"
						className={classNames({'nav-active': useMatch('/feeds/*') !== null})}
						variant="minimal"
						text="Feeds"
					/>
				</Link>

				<Link to="/files">
					<Button
						icon="document"
						className={classNames({'nav-active': useMatch('/files/*') !== null})}
						variant="minimal"
						text="Files"
					/>
				</Link>

				<Link to="/scripts">
					<Button
						icon="code-block"
						className={classNames({'nav-active': useMatch('/scripts/*') !== null})}
						variant="minimal"
						text="Scripts"
					/>
				</Link>

				<Link to="/providers">
					<Button
						icon="third-party"
						className={classNames({'nav-active': useMatch('/providers/*') !== null})}
						variant="minimal"
						text="Providers"
					/>
				</Link>
			</BpNavbar.Group>

			<BpNavbar.Group align="end">
				<Button variant="minimal" text="Logout" onClick={onLogoutClick} />
			</BpNavbar.Group>
		</BpNavbar>
	);
}
